import { h, } from "preact";

import { Button, Typography, Box, Paper, Stack } from "@mui/material";



export default function Inscription(props) {
	return (
		<Box style="min-height: 500px" display="flex" justifyContent="center" alignItems="center">
			<Paper elevation={3} style="width: 400px; padding: 10px;">

				<Stack spacing={1}>
					<Box display="flex" justifyContent="center" mx="auto" m={1} p={1}>
						<Typography variant="h5">Bienvenue !</Typography>
					</Box>

					<Box display="flex" justifyContent="center" mx="auto" m={1} p={1}>
						<Typography variant="h5">Vous souhaitez...</Typography>
					</Box>

					<Box display="flex" justifyContent="center" mx="auto" m={1} p={1}>
						<Stack spacing={2}>

							<Paper
								style="padding: 8px; background-color: #f2f2f2; border-color: #ff3426; border-width: 1px; cursor: pointer;"
								onClick={() => { window.location.href = "/devenir-vendeur" }}
							>
								<Stack spacing={1}>
									<Typography variant="h5" color="primary">Vendre un bien</Typography>
									<Typography>Obtenez le meilleur net vendeur du marché</Typography>
								</Stack>
							</Paper>
							<Paper
								style="padding: 8px; background-color: #f2f2f2; border-color: #ff3426; border-width: 1px; cursor: pointer;"
								onClick={() => { window.location.href = "/devenir-acquereur" }}
							>
								<Stack spacing={1}>
									<Typography variant="h5" color="primary">Acheter un bien</Typography>
									<Typography>Obtenez l’adresse exacte de votre futur bien</Typography>
									<Typography>Et prenez rendez-vous en ligne</Typography>
								</Stack>
							</Paper>
							<Paper
								style="padding: 8px; background-color: #f2f2f2; border-color: #ff3426; border-width: 1px; cursor: pointer;"
								onClick={() => { window.location.href = "/devenir-ambassadeur" }}
							>
								<Stack spacing={1}>
									<Typography variant="h5" color="primary">Etre ambassadeur</Typography>
									<Typography>Percevez 50 % des honoraires Bkeys</Typography>
								</Stack>
							</Paper>

						</Stack>
					</Box>
				</Stack >
			</Paper >
		</Box >
	);
}

